package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class DashboardStatsDto(
    val revenue: String,
    val bookingCount: Long,
    val averageRating: Double,
    val period: String
)

@Serializable
data class DashboardChartDto(
    val period: String,
    val revenuePoints: List<ChartPointDto>,
    val bookingPoints: List<ChartPointDto>,
    val statusDistribution: Map<String, Int>,
    val heatmap: List<List<Int>> = emptyList()
)

@Serializable
data class ChartPointDto(
    val label: String,
    val value: Double
)
